import React from "react";
import SuccessList from "./SuccessList";

const SuccessArea = () => {
  return (
    <section className="success-area pb-120">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 order-0 order-lg-2">
            <div className="success-img">
              <img
                src="/img/images/success_imgs.png"
                alt="Vernu Stoffering werk in uitvoering"
              />
            </div>
          </div>
          <div className="col-lg-6">
            <div className="success-content">
              <div className="section-title title-style-two mb-30">
                <span className="sub-title">Onze Kwaliteit</span>
                <h2 className="title">
                  Wat Vernu Stoffering Onderscheidt in Vakmanschap
                </h2>
              </div>
              <p>
                Al jaren realiseren wij succesvolle stoffeerprojecten dankzij
                een combinatie van vakkennis, duurzame materialen en maatwerk.
                Onze klanten waarderen ons om onze precisie, communicatie en
                hoogwaardige afwerking.
              </p>

              <SuccessList />
            </div>
          </div>
        </div>
      </div>

      <div className="success-shape-wrap" aria-hidden="true">
        <img src="/img/images/success_shape01.png" alt="Icon met animatie" />
        <img src="/img/images/success_shape02.png" alt="Icon met animatie" />
      </div>
    </section>
  );
};

export default SuccessArea;
